import { Component, OnInit } from '@angular/core';
import {TitleComponent} from "../title/title.component";
import {Router} from "@angular/router";

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css']
})
export class PrivacyComponent implements OnInit {

  constructor(
    public title : TitleComponent,
    public router: Router


  ) { }

  ngOnInit() {
   
  }



  goToLink(){
    this.router.navigate(['/login']);

  }

}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/privacy/privacy.component.ts